import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import { H3, P, Description } from "../components/typography";
import { withState } from "recompose";
import { getGraphNode } from "../selectors";
import NavBar from "../components/NavBar";
import AspectImage from "../components/atoms/AspectImage";
import Quote from "../components/HeroQuote";
import Pad from "../components/blocks/Pad";
import { HFlexFlipper } from "../components/blocks/Flex";
import { HideDesktop } from "../components/blocks/Responsive";
import Spacer from "../components/blocks/Spacer";
import Background from "../components/blocks/Background";
import ContentSection from "../components/blocks/ContentSection";
import Section from "../components/blocks/Section";
import Couple from "../components/Couple";
import Card from "../components/PictureCard";
import Waypoint from "react-waypoint";
import HeroMission from "../components/HeroMission";
import favicon from "../../assets/logofavcon@2x.png";
import theme from "../styles/theme";

const FadeOut = styled.div`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s;
`;

const GlobeWrapper = styled.div`
  flex: 4;
  margin-left: -2rem;

  ${props => props.theme.media.tablet`
    margin-left: 0rem;
    padding-right: 3rem;
  `};
`;

const GlobeImage = styled.img`
  width: 100%;

  ${props => props.theme.media.mobile`
    width: 80%;
    padding-right: 1rem;
    padding-bottom: 1rem;
  `};
`;

const Impact = styled.div`
  flex: 5;
  padding-left: 6rem;

  ${props => props.theme.media.tablet`
    padding-left: 1rem;
    padding-right: 1rem;
  `};
`;

const MissionPage = ({ background, onColorChange, data }) => {
  const content = getGraphNode(data, "MissionPage");
  return (
    <div>
      <Background>
        <Helmet
          title="Contraline Mission"
          meta={[{ name: "Contraline", content: "Mission" }]}
        >
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <NavBar color="dark" />
        <HeroMission
          serif
          src={content.heroImages}
          quote={content.heroQuote}
          descriptions={content.heroImageDescriptions.heroImageDescriptions.split(
            "|"
          )}
          style={{ flex: 1 }}
        />
        <FadeOut visible={background !== "teal"}>
          <Pad v={8}>
            <Spacer span={4} />
            <Quote fontColor="dark" quote={content.secondQuote} />
          </Pad>
        </FadeOut>
        <Pad v={0}>
          <Waypoint
            bottomOffset={"40%"}
            topOffset={"40%"}
            onEnter={() => onColorChange("teal")}
            onLeave={() => onColorChange("transparent")}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column"
              }}
            >
              <Quote
                fontColor="white"
                quote={content.missionStatement.missionStatement}
                padding={"0rem 6.25rem 12rem 6.25rem"}
                zIndex={3}
              />
            </div>
          </Waypoint>
          <div
            style={{
              background: theme.colors.teal,
              pointerEvents: "none",
              position: "fixed",
              opacity: background === "teal" ? 1 : 0,
              transition: "opacity 1000ms",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 2
            }}
          />
        </Pad>
        <Section v={8}>
          <HFlexFlipper>
            <GlobeWrapper>
              <GlobeImage src={content.globe.responsiveResolution.src} />
            </GlobeWrapper>
            <Impact>
              <H3>
                {content.impactTitle}
              </H3>
              <P>
                {content.impactStatistic.impactStatistic}
              </P>
              <Spacer span={0.5} />
              <Description>
                {content.impactAttribution}
              </Description>
            </Impact>
          </HFlexFlipper>
        </Section>
        <Spacer span={4} />
        <FadeOut visible={background !== "teal"}>
          <Background color="halfGrey">
            <Card
              picture={content.paulTurekImage.responsiveResolution.src}
              title={content.paulTurekTitle}
              text={`"${content.paulTurekBody.paulTurekBody}"`}
              subtitle={content.paulTurekSubtitle}
            />
          </Background>
          <ContentSection
            color="greyLight"
            titleText={content.grandTeamTitle}
            join
            bodyText={content.grandTeamBody.grandTeamBody.split("|")}
            link={{ label: content.grandTeamLink, to: "/team" }}
          />
        </FadeOut>
      </Background>
    </div>
  );
};

const enhance = withState("background", "onColorChange", "transparent");

export default enhance(MissionPage);

export const pageQuery = graphql`
  query MissionPageQuery {
    allContentfulMissionPage {
      edges {
        node {
          heroQuote
          heroImages {
            description
            responsiveResolution(width: 600, quality: 70) {
              src
            }
          }
          heroImageDescriptions {
            heroImageDescriptions
          }
          secondQuote
          missionStatement {
            missionStatement
          }
          paulTurekImage {
            responsiveResolution(width: 800, quality: 70) {
              src
            }
          }
          paulTurekTitle
          paulTurekSubtitle
          paulTurekBody {
            paulTurekBody
          }
          grandTeamTitle
          grandTeamBody {
            grandTeamBody
          }
          grandTeamLink
          globe {
            responsiveResolution(width: 800, quality: 70) {
              src
            }
          }
          impactTitle
          impactStatistic {
            impactStatistic
          }
          impactAttribution
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/mission.js